import React, { useEffect, useState } from "react";
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from "../layouts/TagInputs";
import { usePatient } from "../../contexts";
import SuccessModal from "../modals/SuccessModal";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { get, post, put } from "../../utility/fetch";
import { formatDate, gender, numberWithCommas } from "../../utility/general";
import Spinner from "../UI/Spinner";
import notification from "../../utility/notification";
import SpeechToTextButton from "../UI/SpeechToTextButton";
import GhostTextCompletion from "../layouts/TextPrediction";
import PhoneInput from "../layouts/PhoneInput";

function WalkIn({ details, labRequest, patientData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [payload, setPayload] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
    email: "",
    phoneNumber: "",
  })
  const [labTechs, setLabTechs] = useState([])
  const [loading, setLoading] = useState(false);
  const [selectedServices, setSelectedServices] = useState();
  const [labServices, setLabServices] = useState([]);
  const [view, setView] = useState('reg')
  const [activeId, setActiveId] = useState(0)
  const [active, setActive] = useState(0)
  const [walkInInfo, setWalkInInfo] = useState([])
  const [fade, setFade] = useState("fade-in");
  const { patientInfo } = usePatient()
  const navigate = useNavigate()

  const openModal = () => {
    setIsModalOpen(true);
  };


  const handleServiceChange = (value) => {
    setPayload((prev) => ({
      ...prev,
      walkInTestRequests: value?.map((item) => ({
        internalLabServiceId: item?.value
      }))
    }));
  }

  const getLabServices = async () => {
    let res = await get(`/internallabservice/list/1/1000`);
    setLabServices(res?.data?.recordList.map((service) => (
      {
        label: service?.name,
        value: service?.id,
        amount: service?.cost,
      }
    )))
    console.log(res);
  }

  const handleLabTechChange = (event) => {
    console.log(event)
    setSelectedServices(event?.value);
    // setPayload({...payload, labTechnicianId: event.target.value });
  };

  const getlabtech = async () => {
    const response = await axios.get(`${process.env.REACT_APP_SERVICES_URL}/profile/profilebyhealthcareproviderid/${sessionStorage?.getItem("clinicId")}`);
    console.log(response);
    // const data = await response.json()
    setLabTechs(response.data);
    // return data;

  }

  const submitOrder = async () => {
    setLoading(true);
    try {
      let res = await put(`/walkinlabrequest/${walkInInfo?.id}/pay-cash-for-walk-in-lab-service`,
        {
          labServices: walkInInfo?.walkInTestRequests?.map((request) => ({
            walkInTestRequestId: request?.id,
            amount: request?.cost
          }))
        }
      );
      if (res.statusCode === 200) {
        console.log(res);
        notification({ message: res?.data?.message, type: "success" });
        setLoading(false);
        navigate('/procedures');
        openModal();
        // setIsModalOpen(true);
      }
      console.log(res);
    } catch (error) {
      console.error('Error submitting internal lab request:', error);
      setLoading(false);
    }
  }

  const submitInternalLabRequest = async () => {
    setLoading(true);
    try {
      let res = await post(`/walkinpatient`, payload);
      if (res?.statusCode === 200) {
        getWalkInInfo(res?.data?.walkInLabRequestId);
        setPayload({
          firstName: "",
          lastName: "",
          gender: "",
          dateOfBirth: "",
          email: "",
          phoneNumber: "",
        })
        openModal();
        setLoading(false);
      }
      else {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error submitting internal lab request:', error);
      setLoading(false);
    }
  }

  const handleActive = (active) => {
    setActiveId(active?.id);
    setActive(active);
  }

  useEffect(() => {
    getlabtech();
    getLabServices();

    if (patientData) {
      setPayload((prev) => ({
        firstName: patientData.firstName,
        lastName: patientData.lastName,
        gender: patientData?.gender,
        dateOfBirth: patientData?.dateOfBirth,
        email: patientData?.email,
        phoneNumber: patientData?.phoneNumber,
      }));
    }

  }, []);




  const getWalkInInfo = async (id) => {
    let res = await get(`/walkinlabrequest/${id}`);
    setWalkInInfo(res?.data);
    console.log(res);
  }

  const close = () => {
    setIsModalOpen(false);
    setFade("fade-out");
    // closeModal();

  };

  const handleChange = (e) => {
    if (e.target.name === 'severity' || e.target.name === 'weight') {
      setPayload((prev) => ({
        ...prev,
        [e.target.name]: Number(e.target.value)
      }))
    }
    else {
      setPayload((prev) => ({
        ...prev,
        [e.target.name]: e.target.value.replace(" ", "")
      }))
    }
  }


  const pageStyles = {
    padding: '24px',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
      marginTop: '40px',
  };

  const headerStyle = {
    background: 'linear-gradient(90deg, #1C811C 0%, #2E9E2E 100%)',
    padding: '24px',
    borderRadius: '12px',
    marginBottom: '24px',
    boxShadow: '0 4px 16px rgba(28, 129, 28, 0.15)',
  };

  const headerContentStyle = {
    color: '#ffffff',
  };

  const headerTitleStyle = {
    margin: '0 0 8px 0',
    fontSize: '24px',
    fontWeight: '700',
    letterSpacing: '0.5px',
  };

  const headerSubtitleStyle = {
    margin: 0,
    fontSize: '14px',
    opacity: '0.9',
  };

  const cardStyle = {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
  };

  const formStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '20px',
  };

  return (
    <div style={pageStyles}>
      <div style={headerStyle}>
        <div style={headerContentStyle}>
          <h1 style={headerTitleStyle}>New Walk In Patients</h1>
          <p style={headerSubtitleStyle}>Register walk-in patients</p>
        </div>
      </div>

      <div style={cardStyle}>
        {!isModalOpen ? (
          <div style={formStyle}>
            <div>
              <TagInputs
                onChange={handleChange}
                value={payload?.firstName || ''}
                name="firstName"
                label="First Name*"
              />
            </div>
            <div>
              <TagInputs
                onChange={handleChange}
                value={payload?.lastName || ''}
                name="lastName"
                label="Last Name*"
              />
            </div>
            <div>
              <TagInputs
                onChange={handleChange}
                value={payload?.gender || ''}
                name="gender"
                type="select"
                label="Gender*"
                options={gender}
              />
            </div>
            <div>
              <TagInputs
                onChange={handleChange}
                value={formatDate(payload?.dateOfBirth) || ''}
                name="dateOfBirth"
                dateRestriction={'past'}
                type="date"
                label="Date Of Birth*"
              />
            </div>
            <div>
              <TagInputs
                onChange={handleChange}
                value={payload?.email || ''}
                name="email"
                label="Email"
              />
            </div>
            <div style={{marginTop:"10px"}}>
                <PhoneInput
                  onChange={handleChange}
                value={payload?.phoneNumber || ''}
                placeholder="8012345678"
                name="phoneNumber"
                label="Phone Number*"
                  />
              {/* <TagInputs
                onChange={handleChange}
                value={payload?.phoneNumber || ''}
                placeholder="+2348012345678"
                name="phoneNumber"
                label="Phone Number*"
              /> */}
            </div>
            <div style={{ gridColumn: '1/-1', textAlign: 'right', marginTop: '20px' }}>
              <button
                disabled={loading}
                onClick={submitInternalLabRequest}
                style={{
                  backgroundColor: '#1C811C',
                  color: 'white',
                  padding: '12px 24px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: '600',
                  boxShadow: '0 2px 8px rgba(28, 129, 28, 0.2)',
                }}
              >
                {loading ? (
                  <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    Processing <Spinner width={20} height={20} />
                  </span>
                ) : 'Proceed With Request'}
              </button>
            </div>
          </div>
        ) : (
          <div>
            <div style={{ marginBottom: '20px' }}>
              <TagInputs
                label="Select Lab Service"
                onChange={handleServiceChange}
                options={labServices}
                name="referredClinicId"
                type='R-select'
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <TagInputs
                label="Amount"
                value={numberWithCommas(walkInInfo?.walkInTestRequests?.reduce((acc, curr) => acc + curr?.cost, 0))}
                readOnly
              />
            </div>
            <div style={{ textAlign: 'right' }}>
              <button
                disabled={loading}
                onClick={submitOrder}
                style={{
                  backgroundColor: '#1C811C',
                  color: 'white',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '1rem'
                }}
              >
                {loading ? (
                  <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    Processing <Spinner width={20} height={20} />
                  </span>
                ) : 'Place Order'}
              </button>
            </div>
          </div>
        )}

        {isModalOpen && (
          <SuccessModal
            message={"Walk In Lab Request Created Successfully"}
            Name={`${details?.firstName} ${details?.lastName}`}
            closeModal={close}
          />
        )}
      </div>
    </div>
  );
}

export default WalkIn;
